import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const getRequestAddresses = async (houseId) => {
  const res = await request.get(
    `/Request/house_flats/${houseId}`,
    {},
    'При загрузке списка квартир произошла ошибка'
  );
  return res;
};

const useRequestAddresses = (houseId, options) =>
  useQuery(
    queryKeys.requestAddresses(houseId),
    () => getRequestAddresses(houseId),
    options
  );

export default useRequestAddresses;
